import styled from "styled-components";
import DownloadAppPopup from "./DownloadAppPopup";

export const Modal = styled.div`
    position: fixed;
    z-index: 9999;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    // opacity: 0;
    // visibility: hidden;
    transform: scale(1.1);
    transition: visibility 0s linear 0.25s, opacity 0.25s 0s, transform 0.25s;
`;

export const ModalContent = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    /* padding: 1rem 1.5rem; */
    width: 300px;
    height: 300px;
    border-radius: 20px;
    padding: 20px;

    .close {
        border: none;
        border-radius: 100%;
        display: block;
        // float:none; 
    }
`;

export const DownloadButton = styled.a`
    width: 200px;
    padding: 10px;
    background-color: rgb(56, 146, 68);
    border-radius: 5px;
    color: #fff;
`;

export const ShopLogoContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;